import { Button, Icon } from '@timelyapp/react';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'redux/create';
import { exportTimesheetData } from 'redux/modules/superreports.actions';
import type { HoursDetailsFilter } from 'types/hours';
import { isEmailedReport } from 'utils/superreports';
import ExportStatusDialog from './ExportStatusDialog';
import type { ExportStatus } from './types';

interface Props {
  filters: HoursDetailsFilter;
}

/**
 * Exports csv based on the current state of Timesheet datatable
 * In case of large export, the file is emailed and a notification dialog is shown
 */
const QuickExportButton: React.FC<Props> = ({ filters }) => {
  const [exportStatus, setExportStatus] = useState<ExportStatus>('IDLE');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const handleQuickExport = useCallback(async () => {
    setIsLoading(true);
    const response = await dispatch(exportTimesheetData('csv', filters));
    setIsLoading(false);

    if (isEmailedReport(response)) {
      setExportStatus('LARGE_EXPORT');
    } else {
      // Download url
    }
  }, [dispatch, filters]);

  return (
    <div style={{ position: 'relative' }}>
      <Button
        size="small"
        priority="low"
        isLoading={isLoading}
        disabled={isLoading}
        onClick={handleQuickExport}
      >
        <Icon name="Download01Alt" type="solid" />
        <span>Export</span>
      </Button>
      <ExportStatusDialog status={exportStatus} setStatus={setExportStatus} />
    </div>
  );
};

export default QuickExportButton;
